<div class="sticky-child-container" [class.fixed-pallet]="isPalletPostionFix">
  <div class="grid gap-6 items-start">
    <aside class="lg:col-span-2">
      <div class="sticky top-24 z-50">
        <div class="flex-col flex gap-3 bg-black/90 p-2 rounded-2xl shadow-xl ring-1 ring-black/20 w-fit ml-auto">
          <div *ngIf="indexSubProductInfo()?.HistoricalData">
          <a href="javascript:void(0)"  (click)="onExportXls()">
            <img width="25px" height="29px" src="{{ deployUrlHost }}/assets/XLS_icon.png" title="History Download"
              alt="">
          </a>
          </div>
          <a href="javascript:void(0)"  (click)="onExportPdf()">
            <img width="25px" height="29px" src="{{ deployUrlHost }}/assets/PDF_icon.png" title="Index Download" alt="">
          </a>
        </div>
      </div>
    </aside>
  </div>
</div>
